import { render } from "./vital-sign-button-js.vue?vue&type=template&id=6dec600a&scoped=true"
import script from "./vital-sign-button-js.vue?vue&type=script&lang=js"
export * from "./vital-sign-button-js.vue?vue&type=script&lang=js"

import "./vital-sign-button-js.vue?vue&type=style&index=0&id=6dec600a&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dec600a"]])

export default __exports__